
<b-card :class="{ 'table-loading': loading }">
  <template #header>
    <b-col>
      <form @submit.prevent="refreshTable">
        <div class="input-group input-group-flush">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fe fe-search"></i>
            </span>
          </div>

          <input
            v-model="parameters.q"
            :placeholder="__('common.search')"
            class="form-control search"
            type="search"
          />
        </div>
      </form>
    </b-col>

    <b-col
      class="pr-0 pl-0 btn-group-sm d-flex align-items-center"
      cols="auto"
    >
      <slot name="tableHeaderActions" />

      <div v-if="hasFilters" class="filters">
        <DataFilter
          :filters="filters"
          @applyFilters="filterTable"
          @clearFilters="clearFilters"
        >
          <template #filters>
            <slot name="filters" />
          </template>
        </DataFilter>
      </div>

      <slot name="actionsPopover" />
    </b-col>
  </template>

  <slot name="tableBreadcrumbs" />

  <b-list-group class="list my-n3" data-testid="list-card" flush>
    <b-list-group-item
      v-if="tableData && tableData.length <= 0"
      class="text-center text-muted"
    >
      <small>{{ __('common.no-results') }}</small>
    </b-list-group-item>

    <template v-if="customListGroup">
      <b-list-group-item
        v-for="(item, rowIndex) in tableData"
        :key="rowIndex"
      >
        <slot :item="item" name="listGroupItem" />
      </b-list-group-item>
    </template>
    <template v-else>
      <b-list-group-item
        v-for="(item, rowIndex) in tableData"
        :key="rowIndex"
      >
        <b-row align-content="center">
          <b-col
            v-if="getSelectable(item)"
            class="col-checkbox"
            cols="auto flex"
          >
            <Checkbox
              :checked="isRowSelected(item)"
              :name="'selectRow.' + rowIndex"
              class="mb-0 mr-0"
              label=""
              @onChange="
                (event) => {
                  onRowClick(event, item, rowIndex)
                }
              "
            />
          </b-col>
          <b-col cols="auto">
            <slot :item="item" name="iconBlock">
              <div class="avatar avatar-sm">
                <div
                  class="avatar-title font-size-lg rounded-circle text-primary"
                  style="
                    background-color: #f9fbfd;
                    border: 1px solid rgb(227, 235, 246);
                  "
                >
                  <slot :item="item" name="icon" />
                </div>
              </div>
            </slot>
          </b-col>

          <b-col class="ml-n2 d-flex align-items-center">
            <div class="w-100">
              <h4 class="mb-1 label">
                <slot :item="item" name="label" />
                <slot :item="item" name="badge" />
              </h4>
              <p class="small mb-0 description">
                <slot :item="item" name="description" />
              </p>
            </div>
          </b-col>

          <slot :item="item" name="default" />

          <div class="mr-3 d-flex align-items-start">
            <slot :item="item" name="actionButtons" />
          </div>
        </b-row>

        <slot :item="item" name="afterItem" />
        <slot :item="item" name="childItem" />
      </b-list-group-item>
    </template>
  </b-list-group>

  <template v-if="showFooter" #footer>
    <b-row align-content="center">
      <b-pagination
        v-if="meta.perPage < meta.total"
        v-model="currentPage"
        :per-page="meta.perPage"
        :total-rows="meta.total"
        class="col-6 mb-0"
        pills
        size="sm"
        @page-click="changePage"
      />

      <b-col
        :class="{
          'justify-content-between': selectionEnable,
          'justify-content-end': !selectionEnable,
        }"
        :cols="paginationCols"
        class="d-flex align-items-center"
      >
        <small v-if="selectionEnable" class="text-muted">
          {{ selectionText }}
        </small>
        <small class="text-muted">
          {{ paginationText }}
        </small>
      </b-col>
    </b-row>
  </template>
</b-card>
